module.exports = __webpack_public_path__ + "assets/img/3eb3-es-ct.svg";